/* WELCOME10 is for first-time buyers only (Matt 1 Nov; Joe 2 Nov: invitees saw $395 in the cart, then $439 at checkout).
   WELCOME10 is limited in Shopify to customers with no orders, so a past buyer loses it at checkout. To stop the
   bait-and-switch: for anyone we know has bought before, take WELCOME10 out of the cart and hide the
   "first-order gift" teaser.
   "Known past buyer" = signed in with orders (data-orders), or arrived from a past-buyer email (utm_campaign below),
   or this browser has seen either before (localStorage rw_ret). */
(function(){
  var s=document.currentScript, orders=+(s&&s.getAttribute('data-orders')||0);
  var PAST_BUYER_CAMPAIGNS=/^(womens_private|past_buyers|owner_note|exclusive|restock|pair|nl\d)/i;
  var ret=false;
  try{ ret=localStorage.getItem('rw_ret')==='1'; }catch(e){}
  var q=new URLSearchParams(location.search), camp=q.get('utm_campaign')||'';
  if(orders>0 || PAST_BUYER_CAMPAIGNS.test(camp) || q.get('rw_ret')==='1'){ ret=true; try{ localStorage.setItem('rw_ret','1'); }catch(e){} }
  if(!ret) return;
  document.documentElement.classList.add('rw-returning');
  function hideTeaser(root){
    root=root||document;
    [].forEach.call(root.querySelectorAll('*'),function(el){
      if(el.shadowRoot && /first-order gift|WELCOME10|10% off your first/i.test(el.shadowRoot.textContent||'')) el.style.display='none';
      if(el.children.length<4 && /^\s*(your )?first-order gift\s*$/i.test(el.textContent||'')){ var box=el.closest('[class*="teaser"],[class*="Teaser"],[role="dialog"],button,div'); (box||el).style.display='none'; }
    });
  }
  function dropCode(){
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
      var codes=(c.discount_codes||[]).map(function(d){return d.code;});
      if(codes.some(function(x){return /^WELCOME10$/i.test(x);})){
        var keep=codes.filter(function(x){return !/^WELCOME10$/i.test(x);}).join(',');
        return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:keep})})
          .then(function(){ document.dispatchEvent(new CustomEvent('cart:refresh')); try{ window.posthog&&posthog.capture('welcome10_removed_returning',{campaign:camp}); }catch(e){} });
      }
    }).catch(function(){});
  }
  hideTeaser(); dropCode();
  var n=0, iv=setInterval(function(){ hideTeaser(); if(++n>15) clearInterval(iv); },1000);
  document.addEventListener('click',function(e){ var t=e.target; if(t&&t.closest&&t.closest('[href*="/cart"],[data-cart-toggle],.cart-button,[href*="checkout"],[name="checkout"]')) dropCode(); },true);
  window.addEventListener('pageshow',dropCode);
  setInterval(dropCode,5000);
})();
